import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-blacklist',
  templateUrl: './blacklist.component.html',
  styleUrls: ['./blacklist.component.scss']
})
export class BlacklistComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
